import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Showtimes from "../Showtimes/Showtimes.jsx";

Movie.propTypes = {
  movie: PropTypes.object,
};

export default function Movie(props) {
  const { movie } = props;

  return (
    <div className="billboard-movie">
      <div className="row">
        <div className="col-3">
          <Link
            to={`/viziona/pelicula/${movie.slug}`}
            className="billboard-movie-poster"
          >
            <img src={movie.poster} alt={movie.title} />
          </Link>
        </div>
        <div className="col-9">
          <div className="billboard-movie-header">
            <h3 className="billboard-movie-title">{movie.title}</h3>
          </div>
          <Showtimes
            theater="viziona"
            slug={movie.slug}
            showtimes={movie.showtimes}
          />
        </div>
      </div>
    </div>
  );
}
